/**
 * Shared pdf.js worker setup for every react-pdf consumer.
 *
 * The worker is bundled and self-hosted via Vite's asset URL import — a CDN
 * workerSrc (unpkg) breaks behind enterprise egress allowlists. The plain
 * `pdfjs-dist` specifier resolves to react-pdf's own pdfjs-dist copy via npm
 * hoisting, so the worker version always matches the renderer.
 *
 * Import this module for its side effect before rendering a <Document>:
 *
 *   import '@/lib/pdf-worker'
 */
import { pdfjs } from 'react-pdf'
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url'

pdfjs.GlobalWorkerOptions.workerSrc = workerUrl
